var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unauthorized-container"},[_c('h1',[_vm._v("Unauthorized")]),_c('p',[_vm._v("You do not have access to this page.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }